import React, { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";
import "quilljs-markdown/dist/quilljs-markdown-common-style.css";
import { QuillToolbar, uuidToAlphabetical, alphabeticalToUuid } from "./EditorToolbar.js";
import QuillEditor from "./QuillEditor.jsx";

export const FlowGuideEditor = ({
  optionList,
  setSelectedText = () => {},
  rephraseHandler = () => {},
  showAIModal = false,
  setShowAIModal,
  modalLoading = false,
  setModalLoading,
  generatedText = "",
  showTextModal,
  onReplaceClick,
  onRegenerateClick,
  setShowTextModal,
  minWordLength = 10,
  setOptionList,
  editorRef,
  readOnly,
}) => {
  const [toolbar, setToolbar] = useState("");
  const [options, setOptions] = useState([]);
  const [text, setText] = useState("");
  const [idMapping, setIdMapping] = useState({});

  useEffect(() => {
    if (optionList?.length) {
      const mapping = {};
      let documents = JSON.parse(JSON.stringify(optionList));
      const option = documents.map((e) => {
        const newId = uuidToAlphabetical(e.id);
        mapping[newId] = e.id;
        e.id = newId;
        e.value = e.value;
        return e;
      });
      setIdMapping(mapping);
      setOptions(() => option);
      setToolbar(() => documents[0]?.id);
    }
  }, [optionList]);

  useEffect(() => {
    setSelectedText(() => text);
  }, [text]);

  const handleValueChange = (id, ele) => {
    const newOptions = options.map((e, index) => {
      if (e.id === id) {
        e.value = ele;
      }
      return e;
    });
    setOptions(() => newOptions);
    const htmlList = newOptions.map((e) => {
      return {
        id: alphabeticalToUuid(e.id),
        value: e.value,
      };
    });
    setOptionList(() => htmlList);
  };

  return (
    <>
      {options?.map((e) => {
        return <QuillToolbar key={e.id} id={`${e.id}`} show={toolbar == `${e.id}`} />;
      })}

      <div className="custom-editors">
        <div className="editorarea">
          {options?.map((e) => {
            return (
              <QuillEditor
                key={e.id}
                id={`${e.id}`}
                editorRef={editorRef}
                value={e.value}
                setValue={(ele) => handleValueChange(e.id, ele)}
                onFocus={setToolbar}
                currentToolbar={toolbar}
                setText={setText}
                rephraseHandler={rephraseHandler}
                showAIModal={showAIModal}
                setShowAIModal={setShowAIModal}
                modalLoading={modalLoading}
                setModalLoading={setModalLoading}
                generatedText={generatedText}
                idMapping={idMapping}
                showTextModal={showTextModal}
                setShowTextModal={setShowTextModal}
                onReplaceClick={onReplaceClick}
                onRegenerateClick={onRegenerateClick}
                minWordLength={minWordLength}
                readOnly={readOnly}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};
